import React, { useState, useEffect } from "react"
import dateFormat from 'dateformat';

import { Form, Row } from "react-bootstrap"

import InputField from '../elements/input'
import SelectField from '../elements/select'
import TextAreaField from '../elements/textarea'
import CheckboxField from '../elements/checkbox'
import RadioboxField from '../elements/radio'
import ButtonField from '../elements/button'
import HtmlBox from '../elements/html'
import ReCaptchaBox from '../elements/recaptcha'
import '../assets/styles/_index.scss'
import { PageLinks } from "../../../common/page-links";
import { phoneNumberValidation, getUrlParams } from "../../../common/utils/site_utlis"

function Rent_Home_1(props) {

  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showerrormsg, setShowerrorMsg] = useState("");
  const [showthankyou, setThankyou] = useState(false);
  const [startDate, setStartDate] = useState();
  const [startTime, setStartTime] = useState();


  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectError, setSelectError] = useState(false);

  const myRef = React.createRef();


  //console.log("location ==>", location, replace_slashes, props.title);

  var fields = ([
    {
        error_text: "Highlighted fields are required.",
        success_text: "Thank you, a member of our team will be in contact soon.",
    },
    // Step 1
    {
      text: '<b>Property Details</b>',
      element: "html",
      class: "mt-0 content_r-m mb-3 heading_text"
    },
    {
        grpmd: "12",
        label: "Address of Property",
        placeholder: "",
        name: "property_address",
        element: "textarea",
        class: "",
        required: true,
        rows: "4",
        labelClass: "annual-txt",
        errorMsg: "Enter the property address."
    },
    {
        text: 'Let us know the address of the property you are interested in.',
        element: "html",
        class: "content_r-m mb-4"
    }]
    )

    fields.push(
        {
            grpmd: "12",
            label: "Which deposit option would you like?",
            placeholder: "",
            name: "deposit_option",
            element: "radio",
            required: true,
            selected:"",
            values: ['No Deposit Option', "Standard 5 week deposit"],
            labelClass: "annual-txt",
            class: "",
            divclass: "radio_wrap"
        }, 
        {
            text: 'Where available, we offer a No Deposit Option, via our partner Reposit, whereby no damage deposit is payable. Instead, a fee of 1 week’s rent will apply in lieu of a 5 week damage deposit. Please note this option is not available on all properties. Full details will be provided before you proceed with this optional service.<br /><br /> <a href="'+PageLinks.no_deposit+'" target="_blank">Find out more about our no deposit option.</a><br /><br />Where available, you can opt to have your utility bills included in your rent (gas, electricity, water, TV Licence and broadband). This means you have one easy payment each month and no arguments over the bills or when to put the heating on. ',
            element: "html",
            class: "mt-2 content_r-m mb-4"
        },
        {
            grpmd: "12",
            label: "Please Indicate Your Preference",
            placeholder: "",
            name: "your_preference",
            element: "radio",
            required: true,
            selected:"",
            values: ['Yes, we would like to have utility bills included in the rent', 'No, we would prefer to arrange the utility bills ourselves'],
            labelClass: "annual-txt",
            class: "",
            divclass: "radio_wrap"
        }
    )

    fields.push(
        {
            grpmd: "12",
            name: "SUBMIT",
            type: "submit",
            element: "button",
            value: "Next",
            class: "btn btn-green",
            labelClass: "",
            customClass: "custom-button-wrapper mt-4 col-md-12",
            divclass: "form-wrap"
        },
    )


  const handlechange = event => {
    // remove initial empty spaces

    //console.log("event ==>", event.target.name);

    if (event.type === "select") {
      //event.value = event.value.trimStart()

      setSelectedOptions(event);
    } else {
      if (event.target.name === "telephone") {
        var valid_phone = phoneNumberValidation(event.target.value);
        if (valid_phone) {
          event.target.value = valid_phone;
        } else {
          event.target.value = '';
        }
      } else {
        event.target.value = event.target.value.trimStart()
      }
    }

  }


  const handleSubmit = event => {

    const form = event.currentTarget;

    //console.log("event =>", form);

    var form_obj_arr = Object.entries(form);

    //console.log("form_obj_arr =>", form_obj_arr.filter(item => item[1].required === true));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      setShowerrorMsg(fields[0].error_text)

      if (selectedOptions?.value) {
        setSelectError(false);
      } else {
        setSelectError(true);
      }

      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    else {

      event.preventDefault();
      const formsdata = (event.target);

      const json = {}
      Object.keys(formsdata).map(key => {

        if (formsdata[key].type === "checkbox") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = 'yes'
          }
        } else if (formsdata[key].type === "radio") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = formsdata[key].value
          }
        } else {
          json[formsdata[key].name] = formsdata[key].value
        }

      })

      //console.log("formdata step1", json);

      props.setFormvaluesFunc(json);

      props.setStep("step2");
      props.setPrevStep("step1")

      //window.scrollTo(0,0)

      setValidated(false);
      setShowerror(false);
    //   setSelectError(false);
    //   setSelectedOptions({});
      

    //   // reset form
    //   const form = event.target
    //   form.reset();
    //   setStartDate();
    //   setStartTime();

    }
  };

  //console.log("selectedOptions", selectedOptions);

  return (
    <div className="form rent_form">

      {showerror && <div className="alert alert-danger">
        {showerrormsg}
      </div>}
      <div ref={myRef}></div>

      {showthankyou && <div className="alert alert-success">
        {fields[0].success_text}
      </div>}


      <Form name={fields[0].formname} id="step_1" className={props.classNames} action="/" method="post" noValidate validated={validated} onSubmit={handleSubmit} autoComplete="off">

        <Row className="custom-text-field-wrapper no_direction">
          {fields.map((field, index) => {
            if ("input" === field.element) {
              return (
                <InputField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={handlechange}
                  errorMsg={field.errorMsg}
                  startDate={field.type === 'valuation_date' ? startDate : ''}
                  setStartDate={field.type === 'valuation_date' ? setStartDate : ''}
                  startTime={field.type === 'valuation_time' ? startTime : ''}
                  setStartTime={field.type === 'valuation_time' ? setStartTime : ''}
                  defaultValue={field?.defaultValue}
                  min={field?.min}
                  max={field?.max}
                />
              );
            }
            if ("select" === field.element) {
              return (
                <SelectField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  required={field.required}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  values={field.values}
                  key={`${field.element}~${index}`}
                  handlechange={handlechange}
                  componentprops={props}
                  //selectedValue={selectedOptions}
                  errorMsg={field.errorMsg}
                  isError={selectError}
                //isError= {Object.keys(selectError).length > 0 ? (selectError[field.name] ? '' : true) : ''}
                  optionWithLabel={true}
                />
              );
            }
            if ("textarea" === field.element) {
              return (
                <>

                  <TextAreaField
                    name={field.name}
                    divclass={field.divclass}
                    grpmd={field.grpmd}
                    label={field.label}
                    ref={field.ref}
                    rows={field.rows}
                    fieldClass={field.class}
                    labelClass={field.labelClass}
                    placeholder={field.placeholder}
                    required={field.required}
                    key={`${field.element}~${index}`}
                    handlechange={handlechange}
                    errorMsg={field.errorMsg}
                  />
                </>
              );
            }
            if ("checkbox" === field.element) {
              return (
                <CheckboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                />
              );
            }
            if ("radio" === field.element) {
              return (
                <RadioboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  values={field.values}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                  label={field.label}
                />
              );
            }
            if ("html" === field.element) {
              return (
                <HtmlBox
                  text={field.text}
                  fieldClass={field.class}
                  key={`${field.element}~${index}`}
                />
              );
            }
            // if ("captcha" === field.element) {
            //   return (
            //     <ReCaptchaBox
            //       fieldClass={field.class}
            //       captRef={field.captchaRef}
            //       key={`${field.element}~${index}`}
            //       handleonVerify={handleonVerify}
            //     />
            //   );
            // }
            if ("button" === field.element) {
              return (
                <>

                  <ButtonField
                    name={field.name}
                    fieldClass={field.class}
                    type={field.type}
                    value={field.value}
                    key={`${field.element}~${index}`}
                    grpmd={field.grpmd}
                    customClass={field.customClass}
                  />

                </>
              );
            }
          })
          }
        </Row>
      </Form>

    </div>
  );
}


const RentHomeStep1 = (props) => (
  <Rent_Home_1 {...props} />

)

export default RentHomeStep1